<div 
  class="options"
  [ngClass]="{ 'hidden': customStyleService.isCustomStyleDialogOpen || (matcherService.itemsToMatch$ | async).length }"
  *ngIf="!isLoading">
  <div class="options_list">
    <div class="button button--large" (click)="onAccountClick()">
      Account
    </div>
    <div class="button button--large" (click)="onWebLibraryClick()">
      Visit Web Library
    </div>
    <div class="button button--large" (click)="onTutorialClick()">
      Video Tutorial
    </div>
    <div class="button button--large" (click)="openCustomStyleDialog()">
      Manage Custom Bibliography Styles
    </div>
    <div class="button button--large" (click)="toggleAutoBibliographyUpdate()">
      Turn {{ globalsService.isBibliographyAutoUpdateOn ? 'off' : 'on' }} automatic bibliography updates
    </div>
    <div 
      *ngIf="isWord" 
      class="button button--large flex" 
      (click)="toggleSectionsMode()">
      Turn {{ globalsService.isSectionsModeOn ? 'off' : 'on' }} document section bibliographies
      &nbsp; <fa-icon [icon]="['fas', 'info-circle']" (click)="onSectionModeClick($event)"></fa-icon>
    </div>
    <div 
      *ngIf="isWordDesktop" 
      class="button button--large flex" 
      (click)="toggleHyperlinksMode()">
      Turn {{ globalsService.isHyperlinksModeOn ? 'off' : 'on' }} hyperlinks to bibliography
      &nbsp;<fa-icon [icon]="['fas', 'info-circle']" (click)="onHyperlinkLearnMoreClick($event)"></fa-icon>
    </div>
    <!-- <div class="button button--large" (click)="onConvertLegacyClick()">
      Update Existing Citations
    </div> -->
    <div class="button button--large" (click)="onConvertToPlainClick()">
      Convert to Plain Text
    </div>
    <div 
      *ngIf="isWordDesktop"
      class="button button--large" 
      (click)="onConvertFromEndnoteClick()">
      Convert from Endnote
    </div> 
    <div 
      *ngIf="isWordDesktop && (userService.user$ | async)?.organization?.id"
      class="button button--large" 
      (click)="onConvertFromQuosaClick()">
      Convert from Quosa
    </div>
    <div *ngIf="!!globalsService?.appConfig?.convertFromEndnote" class="button button--large" (click)="onRefreshClick()">
      Reload Smartcite
    </div>
    <div class="button button--large" (click)="onSupportClick()">
      Support
    </div>
    <div class="select-box_container">
      <span>Language:</span>
      <select 
        [(ngModel)]="selectedLanguage"
        (change)="onLanguageChange($event)"
        class="form-control">
        <option 
          *ngFor="let language of languages"
          [value]="language.id">
          {{ language.name }}
        </option>
      </select>
    </div>
    <div class="button button--large" (click)="onSignoutClick()">
      Sign Out
    </div>
    <div class="options_faded">
      Logged in as {{ (userService.user$ | async)?.name }}
      <span *ngIf="!globalsService?.appConfig?.environment?.production">
        &#40;{{ (userService.user$ | async)?.email }}&#41;
      </span>
    </div>
  </div>

  <div class="options_faded">
    <div>
      Version: {{ globalsService.appConfig.buildVersion }}
    </div>
  </div>
</div>

<scs-custom-style *ngIf="customStyleService.isCustomStyleDialogOpen"></scs-custom-style>

<scs-matcher *ngIf="(matcherService.itemsToMatch$ | async).length"></scs-matcher>

<div class="loader_overlay" *ngIf="isLoading && !(matcherService.itemsToMatch$ | async).length">
  <scs-loader class="center-horizontal-vertical"></scs-loader>
</div>

